
// onfileSelected: Función que recibe la lista de archivos seleccionados y los setea a la 
//lista original
export const onfileSelected = (fileSelect, filesSelected, setFilesSelected, setOpenMessageFileSize) => {
        console.log("Archivo Seleccionado: ", fileSelect[0]);
    
        Array.from(fileSelect).forEach(selectedFile => {

            if (selectedFile.size > 9999999) { // Si el tamaño del archivo es mayor a 10MB.
                console.log("SUPERA EL TAMANO PERMITIDO")
                // Se setea la lista de archivos seleccionados, con la lista existente, sin agregar elementos.
                setOpenMessageFileSize(true); //Mostrar el mensaje de que el tamaño del archivo es mayor al soportado
                setFilesSelected(filesSelected)
                return filesSelected; 
            }
            const fileExists = filesSelected.some(file => file.name === selectedFile.name);
            if (fileExists) {
                console.log("Ya existe un archivo con ese nombre: ", selectedFile.name);
                return filesSelected
            } else {
                console.log("No existe un archivo con ese nombre: ", selectedFile.name);
                setFilesSelected(prevFiles => [...prevFiles, selectedFile]);
            }
        });
};